module.exports = __webpack_public_path__ + "img/collage_icon_1.fc6582ed.svg";